export default "__VITE_ASSET__C16t1fYe__"